import { api } from "../api/client";
import Icon from "../components/Icon";

export default function LoginPage() {
  const next = window.location.pathname || "/studies";
  const isLocalhost = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

  return (
    <div className="login-screen">
      <div className="login-contour">
        <section className="login-left">
          <h1>
            Abby<span>Researcher</span>
          </h1>
          <div className="login-rule" />
          <p>
            A private research workspace for qualitative cultural anthropology in food security and livelihoods.
          </p>
          <a className="button" href={api.loginUrl(next)}>
            <Icon name="google" size={16} />
            Sign in with Google
          </a>
          {isLocalhost ? (
            <a className="dev-login-link" href={api.devLoginUrl(next)}>
              Local dev login
            </a>
          ) : null}
          <div className="login-foot">Private - single-user - audit trail kept</div>
        </section>
        <section className="login-right" aria-hidden="true">
          <ContourMap />
        </section>
      </div>
    </div>
  );
}

function ContourMap() {
  const paths = [
    "M108 198c-32-19-42-57-20-84 24-30 75-39 116-16 38 21 53 66 33 96-23 34-86 31-129 4Z",
    "M122 190c-23-15-31-43-13-63 19-22 58-27 87-10 28 16 39 49 22 71-18 24-64 23-96 2Z",
    "M140 178c-14-10-18-27-7-39 12-13 36-16 54-6 17 10 23 31 12 44-12 15-39 15-59 1Z",
    "M93 246c-45-2-78-28-75-59 3-33 43-55 91-50 43 4 74 31 70 62-4 32-39 49-86 47Z",
    "M238 272c-44 12-86 0-95-29-10-31 17-65 64-79 43-13 84 1 94 31 10 32-18 64-63 77Z",
    "M185 95c-21-31-16-69 12-84 30-16 73 0 96 35 22 33 14 71-16 86-31 15-70-2-92-37Z",
    "M76 108c-23-3-39-18-36-35 3-18 25-30 50-27 23 3 40 20 36 37-3 18-27 28-50 25Z",
    "M282 176c-24-10-38-31-30-49 8-19 34-27 59-18 24 9 39 32 30 51-8 18-34 25-59 16Z",
  ];
  return (
    <svg viewBox="0 0 360 320" className="contour-svg">
      {paths.map((d, i) => (
        <path key={d} d={d} fill="none" stroke="currentColor" strokeWidth={1.15} opacity={0.16 + i * 0.08} />
      ))}
      <circle cx="214" cy="151" r="3" fill="currentColor" />
      <text x="222" y="154" fontFamily="var(--font-mono)" fontSize="9" fill="currentColor" opacity="0.62">
        site 03
      </text>
    </svg>
  );
}
